import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EmailComponent } from '../../email/email.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-email-format',
  standalone: true,
  imports: [CommonModule, EmailComponent, MatIconModule, ReactiveFormsModule],
  templateUrl: './email-format.component.html',
  styleUrls: ['./email-format.component.scss']
})
export class EmailFormatComponent implements OnInit {
  _signature
  @Input() emailForm: FormGroup;
  @Input() currentLead: any;
  @Input()
  set signatures(value: string) {
    this._signature = value;
  }
  @Input() isSms: boolean = false;
  @Input() isCreate: boolean = true;
  @Input() isSendingMessage: boolean = true;
  @Input() allowConvert: boolean = true;
  @Output() templateChosen = new EventEmitter<any>();
  
  isExpanded = true; // Default to collapsed state for a cleaner look

  constructor() {}

  ngOnInit(): void {
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  newSubject(event: any): void {
    if (this.emailForm.get('subject')) {
      this.emailForm.get('subject').setValue(event.email_subject);
    }

    if (event?.attachments && event.attachments.length > 0) {
      this.templateChosen.emit(event.attachments);
    }else{
      this.templateChosen.emit([]);
    }
  }
}